import React from 'react';
import { Card, Checkbox, Link, Text } from '@heartinternet/hi-ui';

export interface TermsSectionProps {
  sslIssuer: string;
  termsUrl: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  invalid: boolean;
}

/** Terms and Conditions card — mirrors submission/section-terms.js. */
export const TermsSection: React.FC<TermsSectionProps> = ({
  sslIssuer,
  termsUrl,
  checked,
  onChange,
  invalid,
}) => {
  const cardClass = ['hi-ui-ssl-info__section', invalid && 'hi-ui-ssl-info__section--error']
    .filter(Boolean)
    .join(' ');

  return (
    <Card
      className={cardClass}
      variant="surface"
      header={<Text variant="heading-3">Terms and conditions</Text>}
    >
      <div className="hi-ui-ssl-info__section-body">
        <Text variant="body">
          Please read and accept the terms and conditions of the Subscriber Agreement.
        </Text>
        {sslIssuer && <Text variant="body">Certificate Issuer: {sslIssuer}</Text>}
        <Checkbox name="terms" checked={checked} onChange={(e) => onChange(e.target.checked)}>
          I accept the Certificate Issuer&rsquo;s{' '}
          <Link href={termsUrl} target="_blank">
            Terms of Use
          </Link>
        </Checkbox>
        <div className="hi-ui-ssl-info__terms-disclaimer">
          <Text variant="body-small" bold>
            *Clicking the assign button below will send an email to your &quot;admin&quot; email
            account on the domain you are requesting the certificate for (e.g. admin@my-domain.uk).
          </Text>
          <Text variant="body-small" bold>
            If the mailbox does not yet exist, please create one before continuing.
          </Text>
        </div>
      </div>
    </Card>
  );
};
